

function Sound1(url) {
  new Audio(url).play();
}

export default Sound1;
